import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPShopTabsBarUI from './PDPShopTabsBarUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBarPlaceholder';

const PDPShopTabsBarInner = ({ isEditOrder = false }) => {
  const {
    loading: optionsLoading,
    data: { stock, options, upholsteryOptionId, hasSingleOptionType },
  } = usePDPOptions();

  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  const { data: basicDetails } = usePDPBasicDetails();

  const {
    loading: availabilityLoading,
    data: {
      isEFGInternal,
      isMarkedOOSOrDiscontinued,
      isDiscontinued,
      isOutOfStock,
      isStockLoading,
    },
  } = usePDPStockAvailability();

  const price = basicDetails?.meta?.price;

  const shouldShowReadyToShip =
    stock?.showReadyToShip && !basicDetails?.bypass_stock;

  const hideShopsTabBar = !!(
    !availabilityLoading &&
    !optionsLoading &&
    (isEmpty(options) ||
      (isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued) ||
      (isEFGInternal && hasSingleOptionType))
  );

  useEffect(() => {
    if (availabilityLoading || optionsLoading || isEmpty(options)) {
      return;
    }

    if (
      (isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued) ||
      (isEFGInternal && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID)
    ) {
      setPdpSelectedCustomizerTab(PDP_READYTOSHIP_TAB_ID);
    }
  }, [
    availabilityLoading,
    hasSingleOptionType,
    isDiscontinued,
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isOutOfStock,
    options,
    optionsLoading,
    pdpSelectedCustomizerTab,
    setPdpSelectedCustomizerTab,
  ]);

  return (
    <PDPShopTabsBarUI
      hideShopsTabBar={hideShopsTabBar}
      isEFGInternal={isEFGInternal}
      loading={optionsLoading || (isMarkedOOSOrDiscontinued && isStockLoading)}
      price={price}
      showDecideLater={!isEditOrder && !!upholsteryOptionId}
      showReadyToShip={shouldShowReadyToShip}
    />
  );
};

PDPShopTabsBarInner.propTypes = {
  isEditOrder: PropTypes.bool,
};

const PDPShopTabsBar = props => (
  <ReRenderOnMount>
    <SuspenseWithLoader fallback={<PDPShopTabsBarPlaceholder />}>
      <PDPShopTabsBarInner {...props} />
    </SuspenseWithLoader>
  </ReRenderOnMount>
);

export default PDPShopTabsBar;
